import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import DataSourceResource from "../../../DataSource.resource.js";
const defaultReducerState = {
  items: getDefaultAsyncWrapperObj()
};
const prefix = "loadDataSourceProfiling";
const loadProfilingDataSourcesArgs = {
  actionPrefix: `${prefix}/LOAD`,
  reduxKeyNested: () => ["items"],
  loadResource: (inputPayload) => {
    return DataSourceResource.triggerDataProfiling(inputPayload.workspaceId, inputPayload.dataSourceProfiling);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadProfilingDataSourcesEpicReducer = loadResourcesUtils(loadProfilingDataSourcesArgs);
const dataSourceProfilingReducer = (state = defaultReducerState, action) => {
  state = loadProfilingDataSourcesEpicReducer.reduxChange(state, action);
  return state;
};
export {
  dataSourceProfilingReducer,
  dataSourceProfilingReducer as default,
  defaultReducerState,
  loadProfilingDataSourcesEpicReducer
};
//# sourceMappingURL=DataSourceProfiling.ducks.js.map
